export function getUserCountry() {
  const language = window.navigator.userLanguage || window.navigator.language
  if (language === "en-GB") return "United Kingdom"
  return "United States"
}
